module.exports = __webpack_public_path__ + "img/icon-leads-v2.ccf7c38f.svg";